// extracted by mini-css-extract-plugin
export default {"container":"product-post_container__s-xf8","image_container":"product-post_image_container__1CV5r","fields_container":"product-post_fields_container__9DLOe"};